/**
 * States of a work order
 *
 * @export
 * @enum {number}
 */
export enum WorkOrderStatuses {
  Created = 1,
  Started = 2,
  Assigned = 3,
  Parked = 5,
  Closed = 7,
  Cancelled = 8,
  AwaitingAudit = 9,
  AwaitingAssetAssignment = 11,
  PendingApproval = 12,
  Approved = 13,
  InProgress = 14,
  Reject = 15,
  AwaitingApproval = 16,
  LinkWOCreated = 17,
}

export enum WorkOrderTaskStatuses {
  Pending = 1,
  Started = 2,
  Paused = 3,
  Complete = 4,
}

/**
 * Specific views for the work order console
 *
 * @export
 * @enum {number}
 */
export enum WorkOrderViews {
  All = 0,
  PM = 1,
  Overdue = 2,
  DueToday = 3,
  AssignedToMe = 4,
  Guest = 5,
  SaveView = 6,
  LoadView = 7,
}

/**
 * Sorting options for work order console
 *
 * @export
 * @enum {number}
 */
export enum WorkOrderSorts {
  WoNum = 0,
  Action = 1,
  LastUpdate = 2,
  RegisterTime = 3,
  DueDate = 4,
  Priority = 5,
  ParentWO = 6,
}

/**
 * Grouping options for work order console
 *
 * @export
 * @enum {number}
 */
export enum WorkOrderSearchGroupBy {
  None = 0,
  Property = 1,
  Location = 2,
  Source = 3,
  Type = 4,
  DueDate = 5,
  Status = 6,
  Priority = 7,
  Asset = 8,
  CheckList = 10,
  Staff = 11,
}

/**
 * Additional filters for work orders.
 * These will be usually applied over the selected console view
 *
 * @export
 * @enum {number}
 */
export enum WorkOrderFilters {
  Type = 2,
  Source = 3,
  AssignedStaff = 4,
  Assets = 5,
  AssetCategory = 6,
  Locations = 7,
  PM = 8,
  Description = 9,
}

/**
 * Source from where the work order was generated
 *
 * @export
 * @enum {number}
 */
export enum WorkOrderSource {
  Staff = 0,
  Guest,
  PM,
}
